// 3rd Party
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import { Div, FlexRow } from 'common/styles/oc-styled-components';

import AchievementsInfo from '../AchievementsInfo/AchievementsInfo';
import ProfileImageCircles from '../../../common/components/ProfileImageCircles/ProfileImageCircles';
import {
  ProfileSubsectionHeader,
  ProfileSubsectionTitle,
  ProfileSubsectionBody,
} from '../../profile-styled-components';
import ProviderAboutText from '../ProviderAboutText/ProviderAboutText';

// Other
import { PROFILE_ACHIEVEMENT_SECTION_TYPES } from '../../constants/constants';
import { getProviderAchievements } from '../../helpers/profile-helpers';
import { selectDataClinic } from '../../connect/selectors';

// Component
const ProviderSingleInfo = ({ providerId }) => {
  const clinic = useSelector(selectDataClinic);
  const provider = _.find(clinic.providers, p => p.id === providerId);
  const { doctor } = provider;
  const {
    about,
    metadata,
    name,
    primaryPhoto,
    questionResponses,
    specialties,
  } = doctor;

  const awards = getProviderAchievements(
    clinic.address,
    provider.onlineBooking === true,
    metadata,
    specialties,
    'Awards',
    PROFILE_ACHIEVEMENT_SECTION_TYPES.awards,
  );
  const educationCertifications = getProviderAchievements(
    clinic.address,
    provider.onlineBooking === true,
    metadata,
    specialties,
    'Education & Certifications',
    PROFILE_ACHIEVEMENT_SECTION_TYPES.educationCertifications,
  );

  return (
    <>
      <section>
        <ProfileSubsectionHeader>
          <ProfileSubsectionTitle>{name}</ProfileSubsectionTitle>
        </ProfileSubsectionHeader>

        {(about || questionResponses.length > 0) 
          && (
            <ProfileSubsectionBody>
              <FlexRow>
                <ProfileImageCircles
                  height="100px"
                  images={[{ ...primaryPhoto, altText: name }]}
                  width="100px"
                />
                <Div margin="0 20px">
                  <ProviderAboutText
                    about={about}
                    questionResponses={questionResponses}
                  />
                </Div>
              </FlexRow>
            </ProfileSubsectionBody>
          )
        }
      </section>
      {awards.length !== 0 
        && (
          <section>
            <ProfileSubsectionHeader>
              <ProfileSubsectionTitle fontSize="18px">
                Awards
              </ProfileSubsectionTitle>
            </ProfileSubsectionHeader>
            <ProfileSubsectionBody>
              <AchievementsInfo achievements={awards} hideTitle title="Awards" />
            </ProfileSubsectionBody>
          </section>
        )
      }
      {educationCertifications.length !== 0 
        && (
          <section>
            <ProfileSubsectionHeader>
              <ProfileSubsectionTitle fontSize="18px">
                Education & Certifications
              </ProfileSubsectionTitle>
            </ProfileSubsectionHeader>
            <ProfileSubsectionBody>
              <AchievementsInfo
                achievements={educationCertifications}
                hideTitle
                title="Education & Certifications"
              />
            </ProfileSubsectionBody>
          </section>
        )
      }
    </>
  );
};

ProviderSingleInfo.propTypes = {
  providerId: PropTypes.number,
};

export default ProviderSingleInfo;
